// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var SizeMap;
(function (SizeMap) {
    SizeMap["Large"] = "large";
    SizeMap["Medium"] = "medium";
    SizeMap["Small"] = "small";
    SizeMap["XLarge"] = "x-large";
    SizeMap["XSmall"] = "x-small";
})(SizeMap || (SizeMap = {}));
